var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 234,
    height: 96,
    viewBox: "0 0 234 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.375 35.5H160.625L107 2.5L53.375 35.5Z",
    stroke: "#DEDEDE",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.875 35.5V76.75",
    stroke: "#DEDEDE",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.625 35.5V76.75",
    stroke: "#DEDEDE",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M119.375 35.5V76.75",
    stroke: "#DEDEDE",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M144.125 35.5V76.75",
    stroke: "#DEDEDE",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 76.75H156.5",
    stroke: "#DEDEDE",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.25 93.25H164.75",
    stroke: "#DEDEDE",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 195.5,
    cy: 25.5,
    r: 22.5,
    fill: "#FCD7FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M196 31C200.971 31 205 26.9706 205 22C205 17.0294 200.971 13 196 13C191.029 13 187 17.0294 187 22C187 26.9706 191.029 31 196 31Z",
    stroke: "#FF6CD3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M183 38C184.593 35.808 186.582 34.0453 188.828 32.836C191.074 31.6267 193.522 31 196 31C198.478 31 200.926 31.6267 203.172 32.836C205.418 34.0453 207.407 35.808 209 38",
    stroke: "#FF6CD3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.c2355301db75f83047d180fa5ae9db5a.svg";
export { ForwardRef as ReactComponent };